var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "e94ae2e6dca2b00977414658c2100ee5ff5d9392"
};
_global.SENTRY_RELEASES = _global.SENTRY_RELEASES || {};
_global.SENTRY_RELEASES["frontend-nextrequest@nextrequest"] = {
  id: "e94ae2e6dca2b00977414658c2100ee5ff5d9392"
};